import CustomTooltip from '@/components/ToolTip/CustomTooltip';
import styled from '@emotion/styled';
import { KeyboardArrowRight } from '@mui/icons-material';
import { ListItemIcon as MuiListItemIcon, MenuItem as MuiMenuItem, Typography } from '@mui/material';
import { ReactNode } from 'react';

const MenuItem = styled(MuiMenuItem)`
    border-radius: 8px;
    padding: 1rem;
`;

const ListItemIcon = styled(MuiListItemIcon)`
    min-width: 3.2rem;
`;

const ListItemEndIcon = styled(MuiListItemIcon)`
    width: 14px;
    margin-left: 8px;
`;

const RightArrow = styled(KeyboardArrowRight)`
    position: absolute;
    right: 4px;
    height: 1.8rem;
    width: 1.8rem;
`;

interface Props {
    title: string;
    onClick?: (e: any) => void;
    disabled: boolean;
    shareTooltip?: string;
    icon?: any;
    endIcon?: any;
    hasRightArrow?: boolean;
}

function ListItemText({ children, className }: { children: ReactNode; className?: string }) {
    return (
        <Typography variant="h5" fontWeight={600} className={className}>
            {children}
        </Typography>
    );
}

const ShareMenuItem = ({ title, onClick, disabled, shareTooltip, icon, hasRightArrow, endIcon }: Props) => {
    return shareTooltip ? (
        <CustomTooltip display="flex" cursor="pointer" title={shareTooltip} containerWidth="4rem" placement="top">
            <MenuItem disabled={disabled} onClick={onClick}>
                <ListItemIcon>
                    <img src={icon} alt={title} />
                </ListItemIcon>
                <ListItemText>{title}</ListItemText>
            </MenuItem>
        </CustomTooltip>
    ) : (
        <MenuItem disabled={disabled} onClick={onClick}>
            <ListItemIcon>
                <img src={icon} alt={title} />
            </ListItemIcon>
            <ListItemText>{title}</ListItemText>
            {hasRightArrow && <RightArrow />}
            {endIcon && (
                <ListItemEndIcon>
                    <img src={endIcon} alt={title} />
                </ListItemEndIcon>
            )}
        </MenuItem>
    );
};

export default ShareMenuItem;
